import React from 'react'

import { TextField } from '@front/squirtle'
import { I18n } from '@front/volcanion'

import { Grid, Typography } from '@mui/material'

const SendMessageDriverForm = ({ popupTitle }) =>
  <Grid container rowSpacing={1.5} >
    <Grid size={12}>
      <Typography sx={{ fontSize: 'h5.fontSize', letterSpacing: 2, color: 'primary.main' }}>{popupTitle} </Typography>
    </Grid>
    <Grid size={12}>
      <TextField label={I18n.t('title.label', { count: 1 })} name={'title'} disabled />
    </Grid>
    <Grid size={12}>
      <TextField
        label={I18n.t('message.label', { count: 1 })}
        name={'text'}
        multiline
        minRows={2}
      />
    </Grid>
  </Grid>

export default SendMessageDriverForm
